import { Text } from '@/components/text';
import { Colors } from '@/constants/theme';
import React, { useState } from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withSpring } from 'react-native-reanimated';
import { Pressable as TWPressable } from './tw-wrappers';

export function Button({
  label,
  onPress,
  variant = 'primary',
  disabled,
  style,
  className,
  outlinedUntilHover,
}: {
  label: string;
  onPress: () => void;
  variant?: 'primary' | 'secondary' | 'ghost';
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  className?: string;
  outlinedUntilHover?: boolean;
}) {
  const pressed = useSharedValue(0);
  const [hovered, setHovered] = useState(false);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ scale: withSpring(pressed.value ? 0.96 : 1) }],
  }));

  const isPrimary = variant === 'primary';
  const showOutlined = outlinedUntilHover && !hovered && isPrimary;

  return (
    <Animated.View style={animatedStyle}>
      <TWPressable
        onPress={onPress}
        onPressIn={() => {
          pressed.value = 1;
        }}
        onPressOut={() => {
          pressed.value = 0;
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        disabled={disabled}
        className={className}
        style={[
          styles.base,
          isPrimary
            ? showOutlined
              ? styles.primaryOutlined
              : styles.primary
            : variant === 'secondary'
            ? styles.secondary
            : styles.ghost,
          disabled && styles.disabled,
          style,
        ]}>
        <Text
          type='defaultSemiBold'
          style={{
            color: isPrimary ? (showOutlined ? Colors.light.primary : 'white') : 'black',
          }}>
          {label}
        </Text>
      </TWPressable>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  base: {
    paddingHorizontal: 24,
    paddingVertical: 10,
    borderRadius: 5000,
    borderWidth: 1,
    alignSelf: 'flex-start',
  },
  primary: { backgroundColor: Colors.light.primary, borderWidth: 1, borderColor: Colors.light.primary },
  primaryOutlined: { backgroundColor: 'transparent', borderWidth: 1, borderColor: Colors.light.primary },
  secondary: { borderColor: 'rgba(0,0,0,0.15)' },
  ghost: { backgroundColor: 'transparent', borderWidth: 0 },
  disabled: { opacity: 0.45 },
});

